
















import {
  Component,
  Vue,
} from 'vue-property-decorator'

@Component < ConfirmRouteChangeDialog > ({})
export default class ConfirmRouteChangeDialog extends Vue {

  public get display(): boolean {
    return this.$store.getters.shouldShowConfirmRouteChangeDialog
  }

  public valid() {
    this.close()
    this.$router.push({
      path: this.$store.getters.pathToGoIfModalIsConfirmed,
    })
  }

  public cancel() {
    this.$store.dispatch('thereIsUnsavedWork')
    this.close()
  }

  public close() {
    this.$store.dispatch('closeConfirmRouteChangeDialog')
  }

}
